import React from "react";
import { Star } from "lucide-react";
import { FadeUp } from "./FadeUp";

const TESTIMONIALS = [
  {
    name: "Mike Jenkins",
    role: "Master Plumber",
    text: "I used to live on referrals. Now people find my site and send a quote while I'm on a call. Setup took a few minutes.",
  },
  {
    name: "David Thompson",
    role: "Electrical Contractor",
    text: "The quote form saves me the back-and-forth. The site looks like a real company, which helps on bigger jobs.",
  },
  {
    name: "Sarah Rodriguez",
    role: "General Contractor",
    text: "I don't build websites. I answered a few questions and got a site I would have paid an agency for. $9/month.",
  },
];

export const TestimonialsSection: React.FC = () => (
  <section className="py-24 bg-muted border-t border-border">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <FadeUp>
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4 tracking-tight font-display">
            From people in the trade
          </h2>
          <div className="w-20 h-1.5 bg-premium-500 mx-auto mb-6 rounded-full" />
        </div>
      </FadeUp>

      <div className="grid md:grid-cols-3 gap-8">
        {TESTIMONIALS.map((testimonial, idx) => (
          <FadeUp key={testimonial.name} delay={0.1 * idx}>
            <div className="bg-card p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow border border-border relative h-full flex flex-col">
              <div className="flex text-premium-500 mb-6">
                {[1, 2, 3, 4, 5].map((star) => (
                  <Star key={star} className="w-5 h-5 fill-current" />
                ))}
              </div>
              <p className="text-muted-foreground text-lg leading-relaxed mb-8 flex-grow">
                &quot;{testimonial.text}&quot;
              </p>
              <div className="flex items-center">
                <div className="w-12 h-12 bg-premium-50 text-premium-600 rounded-full flex items-center justify-center font-bold text-xl mr-4">
                  {testimonial.name.charAt(0)}
                </div>
                <div>
                  <h4 className="font-bold text-foreground">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-muted-foreground font-medium">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
